import { RootStore } from '../data/store'
import { generateRandomString } from '../utils'
import { refreshAPIEndpoints } from './APIEndPoints'

const {
  REACT_APP_BASE_URL,
  REACT_APP_CHANNEL_ID = '',
  REACT_APP_VERSION = '',
  REACT_APP_CAMUNDA_CHANNEL_ID = '',
  REACT_APP_BASE_URL_CITRIX,
} = window?._env_

export const ffsUrl = 'http://ems-fulfill-service-jio-jfs-paap.apps.dev-jpm-ocp-1.ocp.bss.jio.com/'
export const emsUrl = 'http://ems-service-jio-jfs-paap.apps.dev-jpm-ocp-1.ocp.bss.jio.com/'
export const lovUrl = 'http://ems-lov-service-jio-jfs-paap.apps.dev-jpm-ocp-1.ocp.bss.jio.com/'
export const eosUrl = 'http://eos-service-jio-jfs-paap.apps.dev-jpm-ocp-1.ocp.bss.jio.com/'
export const bosUrl = 'http://bos-service-jio-jfs-paap.apps.dev-jpm-ocp-1.ocp.bss.jio.com/'
export const localAppAuth = 'http://10.144.102.190:9001/'

export let sitUrl = REACT_APP_BASE_URL

export const BASE_URL = REACT_APP_BASE_URL

export const appVersion = REACT_APP_VERSION.length > 0 ? `v${REACT_APP_VERSION}` : ''

export const getUrlWithPathVariable = (endPoint: string, pathVariable: string) => {
  return `${endPoint}${pathVariable}`
}

export const updateBaseUrl = (isCitrix: boolean) => {
  sitUrl = isCitrix ? REACT_APP_BASE_URL_CITRIX : BASE_URL
  refreshAPIEndpoints()
}

export const getBaseUrl = () => {
  return sitUrl
}

export const getUrl = (endPoint: string) => {
  return `${endPoint}`
}

export const getHeaders = () => {
  // const token =
  //   'eyJhbGciOiJIUzUxMiJ9.eyJncm91cF9pZCI6MSwiaWQiOjEsInVzZXJuYW1lIjoiSklPUEcuVVNFUiIsInN1YiI6IjEiLCJpYXQiOjE2MDk4NDQ5MDAsImV4cCI6MTYxMDAyNDkwMH0.p3vYrg6Y9dUrIkV0Q_3bK91BumzxufCrvmTdMiD1G7ihGApQ3cyGEDZaVD9i7ZzZGlgBLu3D7SRR3ZkNB-PIKA'
  const token = RootStore.user.token
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  }
}

export const getLocalHeaders = () => {
  // const token =
  //   'eyJhbGciOiJIUzUxMiJ9.eyJncm91cF9pZCI6MSwiaWQiOjEsInVzZXJuYW1lIjoiSklPUEcuVVNFUiIsInN1YiI6IjEiLCJpYXQiOjE2MDk4NDQ5MDAsImV4cCI6MTYxMDAyNDkwMH0.p3vYrg6Y9dUrIkV0Q_3bK91BumzxufCrvmTdMiD1G7ihGApQ3cyGEDZaVD9i7ZzZGlgBLu3D7SRR3ZkNB-PIKA'
  const token = RootStore.user.token
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-channel-id': 322287787654,
    'x-user-id': 'harshit.agrawal',
  }
}

export const eosConfig = (tokens: any) => {
  const { appAccToken, appIdToken, userAccessToken, userIdToken } = tokens
  return {
    baseUrl: eosUrl,
    timeOut: 60000,
    headers: {
      'Content-Type': 'application/json',
      'x-channel-id': REACT_APP_CAMUNDA_CHANNEL_ID ?? '',
      'x-trace-id': generateRandomString(20),
      'x-api-key': 'RPSL Merchant Admin Portal',
      'x-app-access-token': appAccToken || '',
      'x-appid-token': appIdToken || '',
      // 'x-user-access-token': userAccessToken || '',
      // 'x-userid-token': userIdToken || '',
      appIDToken: appIdToken || '',
      // userIDToken: userIdToken || '',
      'x-user-id': `${RootStore.user.name}@ril.com` || '',
    },
    retryCount: 0,
  }
}

export const bosConfig = (tokens: any) => {
  const { appAccToken, appIdToken, userAccessToken, userIdToken } = tokens
  return {
    baseUrl: bosUrl,
    timeOut: 60000,
    headers: {
      'Content-Type': 'application/json',
      'x-channel-id': REACT_APP_CAMUNDA_CHANNEL_ID ?? '',
      'x-trace-id': generateRandomString(20),
      'x-api-key': 'RPSL Merchant Admin Portal',
      'x-app-access-token': appAccToken || '',
      'x-appid-token': appIdToken || '',
      // 'x-user-access-token': userAccessToken || '',
      // 'x-userid-token': userIdToken || '',
      appIDToken: appIdToken || '',
      // userIDToken: userIdToken || '',
      'x-user-id': `${RootStore.user.name}@ril.com` || '',
    },
    retryCount: 0,
  }
}

export const sitConfig = (tokens: any, abortController?: any) => {
  const isCitrixIp = RootStore?.session?.isCitrixIp ?? false
  const { appAccToken, appIdToken, userAccessToken, userIdToken } = tokens
  return {
    baseUrl: isCitrixIp ? REACT_APP_BASE_URL_CITRIX : BASE_URL,
    timeOut: 60000,
    headers: {
      'Content-Type': 'application/json',
      'x-channel-id': REACT_APP_CHANNEL_ID ?? '',
      'x-trace-id': generateRandomString(20),
      'x-api-key': 'RPSL Merchant Admin Portal',
      'x-app-access-token': appAccToken || '',
      'x-appid-token': appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-userid-token': userIdToken || '',
    },
    retryCount: 0,
    abortController,
  }
}


export const sitConfigWithTraceId = (tokens: any, traceId: string, abortController?: any) => {
  const { appAccToken, appIdToken, userAccessToken, userIdToken } = tokens
  return {
    baseUrl: sitUrl,
    timeOut: 60000,
    headers: {
      'Content-Type': 'application/json',
      'x-channel-id': REACT_APP_CHANNEL_ID ?? '',
      'x-trace-id': traceId,
      'x-api-key': 'RPSL Merchant Admin Portal',
      'x-app-access-token': appAccToken || '',
      'x-appid-token': appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-userid-token': userIdToken || '',
    },
    retryCount: 0,
    abortController,
  }
}

export const emsConfig = (tokens: any, appId: any) => {
  const { appAccToken, appIdToken, userAccessToken, userIdToken } = tokens
  return {
    baseUrl: emsUrl,
    timeOut: 60000,
    headers: {
      'Content-Type': 'application/json',
      'x-channel-id': '322287787654',
      'x-trace-id': 'idc',
      // 'x-api-key': 'RPSL Merchant Admin Portal',
      // 'x-app-access-token': appAccToken || '',
      // 'x-appid-token': appIdToken || '',
      // 'x-user-access-token': userAccessToken || '',
      // 'x-userid-token': userIdToken || '',
      appIDToken: appId,
    },
    retryCount: 0,
  }
}

export const localAppAuthConfig = () => {
  return {
    baseUrl: localAppAuth,
    timeOut: 60000,
    headers: {
      'Content-Type': 'application/json',
      'x-channel-id': '322287787654',
      'x-trace-id': 'testing',
    },
    retryCount: 0,
  }
}

export const ffsConfig = (tokens: any) => {
  const { appAccToken, appIdToken, userAccessToken, userIdToken } = tokens
  return {
    baseUrl: ffsUrl,
    timeOut: 60000,
    headers: {
      'Content-Type': 'application/json',
      'x-channel-id': REACT_APP_CHANNEL_ID ?? '',
      'x-trace-id': generateRandomString(20),
      'x-api-key': 'RPSL Merchant Admin Portal',
      'x-app-access-token': appAccToken || '',
      'x-appid-token': appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-userid-token': userIdToken || '',
    },
    retryCount: 0,
  }
}

export const lovConfig = (tokens: any) => {
  const { appAccToken, appIdToken, userAccessToken, userIdToken } = tokens
  return {
    baseUrl: lovUrl,
    timeOut: 60000,
    headers: {
      'Content-Type': 'application/json',
      'X-CHANNEL-ID': REACT_APP_CHANNEL_ID ?? '',
      'X-TRACE-ID': generateRandomString(20),
      'X-API-KEY': 'RPSL Merchant Admin Portal',
      'X-APP-ACCESS-TOKEN': appAccToken || '',
      'X-APPID-TOKEN': appIdToken || '',
      'X-USER-ACCESS-TOKEN': userAccessToken || '',
      'X-USERID-TOKEN': userIdToken || '',
      'X-DEVICE-INFO': 1,
    },
    retryCount: 0,
  }
}

export const usrSessionRefreshConfig = (appAccToken: string, appIdToken: string) => {
  return {
    baseUrl: `${sitUrl}`,
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': 'devportal',
      'x-channel-id': REACT_APP_CHANNEL_ID,
      'x-trace-id': generateRandomString(20),
      'x-app-access-token': appAccToken || '',
      'x-appid-token': appIdToken || '',
    },
    retryCount: 0,
  }
}

export const appSessionRefreshConfig = () => {
  return {
    baseUrl: `${sitUrl}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Channel-ID': REACT_APP_CHANNEL_ID,
      'X-Trace-ID': generateRandomString(20),
    },
    retryCount: 0,
  }
}
